// src/pages/Referentiels.js
import React from "react";
import { Container, Tabs, Tab } from "react-bootstrap";
import GaresList from "./GaresList";
import FonctionsList from "./FonctionsList";
import DistrictsList from "./DistrictsList";
import FournisseursList from "./FournisseursList";

export default function Referentiels() {
  return (
    <Container style={{ maxWidth: 900 }} className="py-4">
      <h4 className="mb-3">Référentiels</h4>

      <Tabs defaultActiveKey="fournisseurs" className="mb-3">
        <Tab eventKey="fournisseurs" title="Fournisseurs">
          <FournisseursList />
        </Tab>

        <Tab eventKey="gares" title="Gares">
          <GaresList />
        </Tab>
        <Tab eventKey="fonctions" title="Fonctions">
          <FonctionsList />
        </Tab>
        <Tab eventKey="districts" title="Districts">
          <DistrictsList />
        </Tab>
      </Tabs>
    </Container>
  );
}
